import React, { useState, useEffect } from 'react';
import { InputAdornment, Snackbar, Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import { DataGrid } from '@material-ui/data-grid';
import { Alert } from '@material-ui/lab';
import styles from './styles';
const ListView = ({ users, setSelectedBuilder, setBuilder }) => {
  const classes = styles.useStyles();
  const { style } = styles;
  const [snackBar, setSnackBar] = useState({ open: false, message: null });

  const [searchResults, setSearchResults] = useState(users);
  useEffect(() => {
    setSearchResults(users);
  }, [users]);

  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const columns = [
    { field: 'name', headerName: 'BUILDER NAME', flex: 1 },
    // { field: 'licence', headerName: 'LICENCE' },
    // { field: 'expiry', headerName: 'EXPIRY' },
    { field: 'phoneNumber', headerName: 'PHONE', flex: 1 },
    { field: 'email', headerName: 'EMAIL', flex: 1 },
    {
      field: 'created_at',
      headerName: 'CREATED AT',
      flex: 1,
      valueFormatter: params => new Date(params.value).toLocaleDateString(),
    },
    {
      field: 'viewPhotos',
      headerName: 'VIEW PHOTOS',
      flex: 1.5,
      renderCell: param => (
        <Button
          variant="contained"
          type="submit"
          style={style.buttonApprove}
          onClick={() => {
            setSelectedBuilder(param.row);
          }}
        >
          View Photos
        </Button>
      ),
    },
    {
      field: 'viewBuilder',
      headerName: 'SEE BUILDER PROFILE',
      flex: 1.6,
      renderCell: param => (
        <Button
          variant="contained"
          type="submit"
          style={style.buttonRej}
          onClick={async () => {
            // viewBuilderProfile
            setBuilder({ ...param.row, username: param.row.businessNumber });
          }}
        >
          SEE BUILDER PROFILE
        </Button>
      ),
    },
  ];

  const handleSubmit = async e => {
    e.preventDefault();
    const searchQuery = e.target[0].value;
    if (searchQuery) {
      const data = users.filter(
        user =>
          user.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          user.email.toLowerCase().includes(searchQuery.toLowerCase()),
      );
      setSearchResults(data);
    } else {
      setSearchResults(users);
    }
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackBar({ open: false });
  };
  return (
    <Grid style={style.inputDiv} xs={12}>
      <div style={style.tableContainer}>
        <form onSubmit={handleSubmit} style={style.inputForm}>
          <TextField
            style={style.searchBox}
            id="standard-full-width"
            label="Search builder by email or name"
            fullWidth
            margin="normal"
            variant="outlined"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Button
                    variant="contained"
                    style={style.button}
                    type="submit"
                  >
                    Search
                  </Button>
                </InputAdornment>
              ),
            }}
          />
        </form>
        {loading ? (
          <div style={style.loadingWrapper}>
            <CircularProgress size={40} />
          </div>
        ) : (
          <DataGrid
            className={classes.root}
            rows={searchResults}
            columns={columns}
            pageSize={10}
            disableColumnMenu
            disableColumnSelector
            density="comfortable"
            disableSelectionOnClick
            autoHeight
          />
        )}

        {/* <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>BUILDER NAME</TableCell>
                <TableCell>LICENCE</TableCell>
                <TableCell>EXPIRY</TableCell>
                <TableCell>PHONE</TableCell>
                <TableCell>EMAIL</TableCell>
                <TableCell align="center">APPROVE</TableCell>
                <TableCell align="center">REJECT</TableCell>
              </TableRow>
            </TableHead>
            <TableBody displayRowCheckbox={false}>
              {pendingUsers.map(row => (
                <TableRow>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row['custom:buildingLicNo']}</TableCell>
                  <TableCell>{row['custom:buildingLicExp']}</TableCell>
                  <TableCell>{row['custom:personalPhone']}</TableCell>
                  <TableCell>{row.email}</TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      type="submit"
                      style={style.buttonApprove}
                    >
                      Approve
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      type="submit"
                      style={style.buttonRej}
                    >
                      Reject
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
  
        <Pagination
          count={5}
          style={style.heading}
          align="center"
          alignItems="center"
          justify="center"
        /> */}
      </div>
      <Snackbar
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={snackBar.open}
        onClose={handleClose}
      >
        <Alert severity="success" onClose={handleClose}>
          {snackBar.message}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default ListView;
